import { useQuery } from "@tanstack/react-query";
import PaymentService from "../services";
import qs from "qs";

interface usePaymrentParams {
  customerId: string;
}
export const usePayments = ({ customerId }: usePaymrentParams) => {
  const query = qs.stringify(
    {
      customerId,
    },
    { encodeValuesOnly: true }
  );

  return useQuery({
    queryKey: ["cards", customerId],
    queryFn: () => PaymentService.getAll({ query }),
    enabled: !!customerId,
  });
};
